import cloneDeep from 'lodash/cloneDeep'
import baseDefaults from '../Base/Base.defaults'

export default {
  ...cloneDeep(baseDefaults),
	beforeText: "Your cart is reserved for the next",
	afterText: "",
	type: 'toDate',
	toDateDate: 'Tue Jun 08 2021 00:00:00 GMT+0200 (Central European Summer Time)',
	daysLabel: 'days, ',
	hoursLabel: 'hours, ',
	minutesLabel: 'minutes, and',
	secondsLabel: 'seconds',
	color: 'var(--color-primary)',
}
